import { render, staticRenderFns } from "./TypeAdd.vue?vue&type=template&id=2460d8f0&scoped=true&"
import script from "./TypeAdd.vue?vue&type=script&lang=js&"
export * from "./TypeAdd.vue?vue&type=script&lang=js&"
import style0 from "./TypeAdd.vue?vue&type=style&index=0&id=2460d8f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2460d8f0",
  null
  
)

export default component.exports